import { Sale } from "@meditect/medibase-api-client";

import { useBoundStore } from "@/features/offline/stores/boundStore";
import { useUserContext } from "@/features/user/useUserContext";

export const getLocalSales = () => {
  const { user } = useUserContext();
  const {
    sale: { sales },
    sessionId,
  } = useBoundStore.getState();
  return sales.filter(
    (sale) => (sale.openedBy === user.id && sale.sessionId === sessionId) || sale.openedBy === undefined,
  );
};

export const hasSaleContent = (sale: Sale): boolean => {
  return sale.records.length > 0 || sale.payments.length > 0;
};

export const isEmptySale = (sale: Sale) => {
  return !hasSaleContent(sale) && !sale.patient;
};

export const createIdentifier = (previous?: Sale): string => {
  const date = new Date();
  if (previous) {
    const splitIdentifier = previous.identifier.split("-");
    return `${splitIdentifier[0]}-${Number(splitIdentifier[1] ?? "0") + 1}`;
  }
  return `${date.getFullYear()}${date?.getMonth() + 1}${date.getDate()}${date.getMilliseconds()}${Math.floor(
    Math.random() * 1000,
  )}`;
};
